const planNames = [
  { name: 'PlayBase Essentials Monthly', userKeySlug: 'PLAYBASE-ESSENTIALS-MONTHLY' },
  { name: 'PlayBase Essentials Half-Yearly', userKeySlug: 'PLAYBASE-ESSENTIALS-YEARLY-HALF' },
  { name: 'PlayBase Essentials Yearly', userKeySlug: 'PLAYBASE-ESSENTIALS-YEARLY' },
  { name: 'PlayBase Plus Monthly', userKeySlug: 'PLAYBASE-PLUS-MONTHLY' },
  { name: 'PlayBase Plus Half-Yearly', userKeySlug: 'PLAYBASE-PLUS-YEARLY-HALF' },
  { name: 'PlayBase Plus Yearly', userKeySlug: 'PLAYBASE-PLUS-YEARLY' },
  { name: 'PlayBase Advanced Monthly', userKeySlug: 'PLAYBASE-ADVANCED-MONTHLY' },
  { name: 'PlayBase Advanced Half-Yearly', userKeySlug: 'PLAYBASE-ADVANCED-YEARLY-HALF' },
  { name: 'PlayBase Advanced Yearly', userKeySlug: 'PLAYBASE-ADVANCED-YEARLY' },
  { name: 'Nexus Prime Monthly', userKeySlug: 'NEXUS-PRIME-MONTHLY' },
  { name: 'Nexus Prime Half-Yearly', userKeySlug: 'NEXUS-PRIME-YEARLY-HALF' },
  { name: 'Nexus Prime Yearly', userKeySlug: 'NEXUS-PRIME-YEARLY' },
  { name: 'Nexus Prime + Live Monthly', userKeySlug: 'NEXUS-PRIME-LIVE-MONTHLY' },
  { name: 'Nexus Prime + Live Half-Yearly', userKeySlug: 'NEXUS-PRIME-LIVE-YEARLY-HALF' },
  { name: 'Nexus Prime + Live Yearly', userKeySlug: 'NEXUS-PRIME-LIVE-YEARLY' },
  { name: 'Nexus Pro Monthly', userKeySlug: 'NEXUS-PRO-MONTHLY' },
  { name: 'Nexus Pro Half-Yearly', userKeySlug: 'NEXUS-PRO-YEARLY-HALF' },
  { name: 'Nexus Pro Yearly', userKeySlug: 'NEXUS-PRO-YEARLY' },
  { name: 'Nexus Pro + Live Monthly', userKeySlug: 'NEXUS-PRO-LIVE-MONTHLY' },
  { name: 'Nexus Pro + Live Half-Yearly', userKeySlug: 'NEXUS-PRO-LIVE-YEARLY-HALF' },
  { name: 'Nexus Pro + Live Yearly', userKeySlug: 'NEXUS-PRO-LIVE-YEARLY' },
  { name: 'Nexus Elite Monthly', userKeySlug: 'NEXUS-ELITE-MONTHLY' },
  { name: 'Nexus Elite Half-Yearly', userKeySlug: 'NEXUS-ELITE-YEARLY-HALF' },
  { name: 'Nexus Elite Yearly', userKeySlug: 'NEXUS-ELITE-YEARLY' },
  { name: 'Student Yearly', userKeySlug: 'STUDENT-YEARLY' }
]

export function getPlanName(userKey) {
  const planData = planNames.find(v => userKey.code.startsWith(v.userKeySlug))
  if (!planData) {
    if (userKey.licence_configuration && userKey.licence_configuration.base_template) {
      const licenceName = userKey.licence_configuration.base_template.name
      if (!userKey.licence_expiration_date && !userKey.licence_expiration_days) {
        return licenceName
      }

      let expirationDays
      if (userKey.licence_expiration_date) {
        const diffTime = Math.abs(
          new Date(userKey.licence_expiration_date) - new Date(userKey.created_at)
        )
        expirationDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      } else {
        expirationDays = userKey.licence_expiration_days
      }

      let cycle
      if (expirationDays >= 8) {
        cycle = 'Yearly'
      } else if (expirationDays >= 4) {
        cycle = 'Half-Yearly'
      } else {
        cycle = 'Monthly'
      }

      return `${licenceName} ${cycle}`
    }

    return 'Unknown'
  }

  return planData.name
}
